export default "__VITE_ASSET__$NNL$U0I__"